import { render } from "./TheTip.vue?vue&type=template&id=0e30e30e&scoped=true"
import script from "./TheTip.vue?vue&type=script&lang=js"
export * from "./TheTip.vue?vue&type=script&lang=js"

import "./TheTip.vue?vue&type=style&index=0&id=0e30e30e&lang=scss&scoped=true"

import exportComponent from "/usr/local/tomcat-jenkins/data/workspace/online-3d-editor-laozicloud3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e30e30e"]])

export default __exports__